import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitConsultation = (payload) => api.post("/leads/consultation", payload);
export const submitCallback = (payload) => api.post("/leads/callback", payload);
export const submitNewsletter = (payload) => api.post("/leads/newsletter", payload);
export const submitChecklist = (payload) => api.post("/leads/checklist", payload);
export const submitContact = (payload) => api.post("/leads/contact", payload);
export const submitAssessment = (payload) => api.post("/assessment/submit", payload);
export const submitProfileDownload = (payload) => api.post("/leads/company-profile", payload);
export const recordNavigatorResult = (payload) => api.post("/leads/navigator-result", payload);

export const adminLogin = (payload) => api.post("/auth/login", payload);
export const getAdminStats = (token) =>
  api.get("/admin/stats", { headers: { Authorization: `Bearer ${token}` } });
export const getAdminLeads = (token) =>
  api.get("/admin/leads", { headers: { Authorization: `Bearer ${token}` } });

export const chatStreamUrl = `${API}/chat/stream`;
